import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { BADGE_ART_LARGE } from '../../assets/badges';
import { celebrationCopy } from '../../utils/badges';

/** "Achievement unlocked" dialog (Figma 849:3295). `extra` = other badges unlocked at the same time. */
export default function AchievementModal({ badge, extra = 0, onClose, onView }) {
  const [shareLabel, setShareLabel] = useState('SHARE');

  useEffect(() => {
    if (!badge) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [badge, onClose]);

  if (!badge) return null;

  const { tier, verb, highlight } = celebrationCopy(badge);
  const more = extra > 0 ? `, plus ${extra} more badge${extra === 1 ? '' : 's'}` : '';
  const shareText = `I just unlocked a ${tier} badge for ${verb} ${highlight} on Padel MVP!\n\nhttps://padelmvp.co.uk`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Achievement unlocked', text: shareText });
      } catch (error) {
        if (error.name !== 'AbortError') console.error('Error sharing:', error);
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(shareText);
      setShareLabel('COPIED');
      setTimeout(() => setShareLabel('SHARE'), 2000);
    } catch (_) {
      setShareLabel('SHARE');
    }
  };

  return createPortal(
    <div className="modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="modal achievement"
        role="dialog"
        aria-modal="true"
        aria-labelledby="achievement-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="profile-menu__header">
          <span className="event-page__icon-btn" aria-hidden="true" />
          <h3 id="achievement-title" className="achievement__title">ACHIEVEMENT UNLOCKED</h3>
          <button type="button" className="event-page__icon-btn" onClick={onClose} aria-label="Close">
            <span className="material-symbols-rounded" aria-hidden="true">close</span>
          </button>
        </div>

        <div className="achievement__body">
          <div className="achievement__art" aria-hidden="true">
            <span className="achievement__rays" />
            <img src={BADGE_ART_LARGE[badge.id]} alt="" width="167" height="169" />
          </div>

          <p className="achievement__text">
            {`You’ve unlocked a ${tier} badge for ${verb} `}
            <span>{highlight}</span>
            {`${more}. Way to go!`}
          </p>

          <div className="achievement__actions">
            <button type="button" className="btn btn-secondary" onClick={handleShare}>
              <span className="btn-text">{shareLabel}</span>
            </button>
            <button type="button" className="btn btn-primary" onClick={onView}>
              <span className="btn-text">VIEW</span>
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
